import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    password2: "",
    signupGuard: "",
  });

  const { firstName, lastName, email, password, password2, signupGuard } =
    formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!firstName.trim() || !lastName.trim()) {
      alert("Please provide both your first and last name.");
      return;
    }
    if (signupGuard) {
      // Honeypot field should remain empty for legitimate users
      alert("Registration failed: Suspicious activity detected.");
      return;
    }
    if (password !== password2) {
      alert("Passwords do not match");
      return;
    }

    const newUser = {
      first_name: firstName.trim(),
      last_name: lastName.trim(),
      email,
      password,
      signup_guard: signupGuard,
    };

    try {
      const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
        body: JSON.stringify(newUser),
      });

      const data = await response.json();

      if (!response.ok) {
        // Handle error response
        alert("Registration failed: " + (data.error || "Unknown error"));
        return;
      }

      // Registration successful - email verification required
      if (data.message) {
        alert(data.message);
      } else {
        alert("Registration successful! Please check your email to verify your account before logging in.");
      }

      // Redirect to login page
      navigate("/login");
    } catch (err) {
      console.error(err.message);
      alert("Registration failed: " + err.message);
    }
  };

  return (
    <div className="form-container">
      <h1>Welcome to Runstreak Dashboard</h1>
      <form onSubmit={onSubmit}>
        <div className="form-group">
          <input
            type="text"
            placeholder="First Name"
            name="firstName"
            value={firstName}
            onChange={onChange}
            required
          />
        </div>
        <div className="form-group">
          <input
            type="text"
            placeholder="Last Name"
            name="lastName"
            value={lastName}
            onChange={onChange}
            required
          />
        </div>
        <div className="form-group">
          <input
            type="email"
            placeholder="Email Address"
            name="email"
            value={email}
            onChange={onChange}
            required
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            placeholder="Password"
            name="password"
            value={password}
            onChange={onChange}
            minLength="6"
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            placeholder="Confirm Password"
            name="password2"
            value={password2}
            onChange={onChange}
            minLength="6"
          />
        </div>
        <div
          style={{
            position: "absolute",
            left: "-10000px",
            top: "auto",
            width: "1px",
            height: "1px",
            overflow: "hidden",
          }}
          aria-hidden="true"
        >
          <label htmlFor="signupGuard">Leave this field blank</label>
          <input
            id="signupGuard"
            type="text"
            name="signupGuard"
            value={signupGuard}
            onChange={onChange}
            tabIndex="-1"
            autoComplete="off"
          />
        </div>
        <input type="submit" value="Register" className="btn btn-primary" />
      </form>
    </div>
  );
};

export default Register;
